import { render, staticRenderFns } from "./RumourArchive.vue?vue&type=template&id=048b0812"
import script from "./RumourArchive.vue?vue&type=script&lang=js"
export * from "./RumourArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('048b0812')) {
      api.createRecord('048b0812', component.options)
    } else {
      api.reload('048b0812', component.options)
    }
    module.hot.accept("./RumourArchive.vue?vue&type=template&id=048b0812", function () {
      api.rerender('048b0812', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/rumour/RumourArchive.vue"
export default component.exports